import {
  Dialog,
  DialogBackdrop,
  DialogPanel,
  Transition,
} from "@headlessui/react";
import { Fragment, useEffect, useState } from "react";
import clockIcon from "../../images/clockIcon.svg";
import { resources_EN } from "../componentUtils";
import { PostService } from "../../services/genericPostService";
import Swal from "sweetalert2";
import moment from "moment";

const AddPopup = ({
  isOpen,
  onClose,
  heading,
  buttonText,
  flag,
  getSchedule,
}) => {
  const userId = localStorage.getItem("userId");
  const [formData, setFormData] = useState({
    taskTitle: "",
  });

  const [startHours, setStartHours] = useState("00");
  const [startMinutes, setStartMinutes] = useState("00");
  const [endHours, setEndHours] = useState("00");
  const [endMinutes, setEndMinutes] = useState("00");
  const [startampm, setStartAmpm] = useState("AM");
  const [endampm, setEndAmpm] = useState("AM");

  console.log("Flag", flag);

  useEffect(() => {
    setStartAmpm(flag === 0 ? "AM" : "PM");
    setEndAmpm(flag === 0 ? "AM" : "PM");
  }, [flag]);

  const onChange = (event) => {
    const { name, value } = event.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  /* Error or Success Modal */
  const modal = (icon, title, message) => {
    Swal.fire({
      icon: icon,
      title: title,
      text: message,
    }).then((response) => {
      if (response.isConfirmed && icon === resources_EN.success) {
        onClose();
        getSchedule();
      }
    });
  };

  const submit = () => {
    const validate = validation();
    if (validate) {
      const startTime = moment({
        hour: startHours,
        minute: startMinutes,
      }).format("HH:mm:ss");
      const endTime = moment({ hour: endHours, minute: endMinutes }).format(
        "HH:mm:ss"
      );

      let data = {
        user_id: userId,
        clock_task_title: formData.taskTitle,
        clock_task_start_time: startTime,
        clock_task_end_time: endTime,
        is_evening_task: flag,
      };

      const url = "/fmeApi/add_clock_task.php";
      PostService(url, data, modal);
    }
  };

  const validation = () => {
    if (formData.taskTitle.trim().length < 1) {
      modal(
        resources_EN.error,
        resources_EN.errorTitle,
        resources_EN.emptyTaskTitleValidation
      );
      return false;
    }
    if (startHours.length < 1) {
      modal(
        resources_EN.error,
        resources_EN.errorTitle,
        resources_EN.emptyTaskStarHour
      );
      return false;
    }
    if (startMinutes.length < 1) {
      modal(
        resources_EN.error,
        resources_EN.errorTitle,
        resources_EN.emptyTaskStartMinute
      );
      return false;
    }
    if (endHours.length < 1) {
      modal(
        resources_EN.error,
        resources_EN.errorTitle,
        resources_EN.emptyTaskEndHour
      );
      return false;
    }
    if (endMinutes.length < 1) {
      modal(
        resources_EN.error,
        resources_EN.errorTitle,
        resources_EN.emptyTaskEndMinute
      );
      return false;
    }
    if (startHours > 12 || startHours < 0 || endHours > 12 || endHours < 0) {
      modal(
        resources_EN.error,
        resources_EN.errorTitle,
        resources_EN.hoursGreaterThanTwelve
      );
      return false;
    }
    if (
      startMinutes > 60 ||
      startMinutes < 0 ||
      endMinutes > 60 ||
      endMinutes < 0
    ) {
      modal(
        resources_EN.error,
        resources_EN.errorTitle,
        resources_EN.minutesGreaterThan60
      );
      return false;
    }

    return true;
  };

  return (
    <Transition appear show={isOpen} as={Fragment}>
      <Dialog as="div" className="relative z-10" onClose={onClose}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <DialogBackdrop className="fixed inset-0 bg-gray-500/75" />
        </Transition.Child>

        <div className="fixed inset-0 z-10 w-full overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4 text-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300 transform"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200 transform"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <DialogPanel className="relative transform overflow-hidden md:rounded-[50px] rounded-[30px] bg-white text-left shadow-xl transition-all sm:w-full sm:max-w-3xl md:p-14 p-8">
                <h2 className="lg:text-3xl text-xl font-semibold mb-8 text-center">
                  {heading}
                </h2>

                <div className="md:p-11 px-0">
                  {/* Title Input */}
                  <div className="space-y-2">
                    <label
                      htmlFor="title"
                      className="block text-lg text-[#464646]"
                    >
                      Task Title *
                    </label>
                    <input
                      type="text"
                      id="title"
                      name="taskTitle"
                      value={formData.taskTitle}
                      onChange={onChange}
                      className="w-full border-b-2 border-gray-300 focus:border-blue-500 focus:outline-none transition duration-300 text-gray-900 text-base py-2"
                      placeholder={`Enter Task Title`}
                    />
                  </div>

                  {/* Start and End Time */}
                  <div className="grid grid-cols-2 md:gap-8 gap-4 mt-6">
                    {/* Start Time */}
                    <div className="space-y-2">
                      <label className="block text-lg text-[#464646] mb-4">
                        Task Start Time *
                      </label>
                      <div className="bg-[#F3F3F3] rounded-2xl md:p-4 p-3">
                        <label className="text-sm font-medium mb-3 block">
                          Enter time
                        </label>
                        <div className="grid grid-cols-3 md:gap-4 gap-3 mb-4">
                          <div className="relative">
                            <input
                              type="number"
                              value={startHours}
                              onChange={(e) => setStartHours(e.target.value)}
                              className="w-full border-2 focus:bg-[#EADDFF] bg-[#E6E0E9] focus:text-[#2BBAF0] focus:border-[#2BBAF0] focus:outline-none rounded-xl py-2 text-center md:text-3xl text-xl text-black"
                              min="1"
                              max="12"
                              required
                            />
                            <label className="text-gray-500 md:text-sm text-xs mb-1">
                              Hour
                            </label>
                            <span className="absolute md:-right-[19%] -right-[23%] md:top-[30%] top-[28%] -translate-y-2/4 md:text-2xl text-lg font-bold text-black">
                              :
                            </span>
                          </div>
                          <div>
                            <input
                              type="number"
                              value={startMinutes}
                              onChange={(e) => setStartMinutes(e.target.value)}
                              className="w-full border-2 focus:bg-[#EADDFF] bg-[#E6E0E9] focus:text-[#2BBAF0] focus:border-[#2BBAF0] focus:outline-none rounded-xl py-2 text-center md:text-3xl text-xl text-black"
                              min="0"
                              max="59"
                              required
                            />
                            <label className="text-gray-500 md:text-sm text-xs mb-1">
                              Minute
                            </label>
                          </div>
                          <div className="flex flex-col rounded-xl overflow-hidden border border-gray-200">
                            <button
                              type="button"
                              className={`md:px-4 px-2 py-2 md:text-md text-xs font-medium ${
                                startampm === "PM"
                                  ? "bg-green text-theme"
                                  : "bg-white text-gray-700"
                              }`}
                            >
                              {startampm}
                            </button>
                          </div>
                        </div>
                        <img src={clockIcon} alt="" />
                      </div>
                    </div>

                    {/* End Time */}
                    <div className="space-y-2">
                      <label className="block text-lg text-[#464646] mb-4">
                        Task End Time *
                      </label>
                      <div className="bg-[#F3F3F3] rounded-2xl md:p-4 p-3">
                        <label className="text-sm font-medium mb-3 block">
                          Enter time
                        </label>
                        <div className="grid grid-cols-3 md:gap-4 gap-3 mb-4">
                          <div className="relative">
                            <input
                              type="number"
                              value={endHours}
                              onChange={(e) => setEndHours(e.target.value)}
                              className="w-full border-2 focus:bg-[#EADDFF] bg-[#E6E0E9] focus:text-[#2BBAF0] focus:border-[#2BBAF0] focus:outline-none rounded-xl py-2 text-center md:text-3xl text-xl text-black"
                              min="1"
                              max="12"
                              required
                            />
                            <label className="text-gray-500 md:text-sm text-xs mb-1">
                              Hour
                            </label>
                            <span className="absolute md:-right-[19%] -right-[23%] md:top-[30%] top-[28%] -translate-y-2/4 md:text-2xl text-lg font-bold text-black">
                              :
                            </span>
                          </div>
                          <div>
                            <input
                              type="number"
                              value={endMinutes}
                              onChange={(e) => setEndMinutes(e.target.value)}
                              className="w-full border-2 focus:bg-[#EADDFF] bg-[#E6E0E9] focus:text-[#2BBAF0] focus:border-[#2BBAF0] focus:outline-none rounded-xl py-2 text-center md:text-3xl text-xl text-black"
                              min="0"
                              max="59"
                              required
                            />
                            <label className="text-gray-500 md:text-sm text-xs mb-1">
                              Minute
                            </label>
                          </div>
                          <div className="flex flex-col rounded-xl overflow-hidden border border-gray-200">
                            <button
                              type="button"
                              className={`md:px-4 px-2 py-2 md:text-md text-xs font-medium ${
                                endampm === "PM"
                                  ? "bg-green text-theme"
                                  : "bg-white text-gray-700"
                              }`}
                            >
                              {endampm}
                            </button>
                          </div>
                        </div>
                        <img src={clockIcon} alt="" />
                      </div>
                    </div>
                  </div>

                  {/* Buttons */}
                  <div className="flex justify-center lg:mt-12 mt-8 flex-wrap-reverse lg:gap-8 gap-4">
                    <button
                      type="button"
                      onClick={onClose}
                      className="py-2.5 px-16 border border-transparent rounded-full text-sm font-normal text-white bg-[#969696] focus:outline-none"
                    >
                      Annuleren
                    </button>
                    <button
                      type="button"
                      onClick={submit}
                      className="py-2.5 px-10 border border-transparent rounded-full text-sm font-normal text-white bg-theme focus:outline-none"
                    >
                      {buttonText}
                    </button>
                  </div>
                </div>
              </DialogPanel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
};

export default AddPopup;
